// extracted by mini-css-extract-plugin
export default {"containerMarginTop":"homepage-mobile-seo-footer-links-MobileSeoFooterLinks__containerMarginTop--2ZjLR"};